import React, { Component } from 'react'
import { PanelGroup, Panel } from 'react-bootstrap'
import MigrationKeyPanel from './MigrationKeyPanel'

class BluehostFAQs extends Component{
	constructor(props){
		super(props)
		this.state = {}
		this.handleFAQSelect = this.handleFAQSelect.bind(this)
	}

	handleFAQSelect(activeFAQKey) {
		let _key = this.state.activeFAQKey
		if (_key && _key == activeFAQKey) {
			this.setState({ activeFAQKey: false })
		} else {
			this.setState({ activeFAQKey: activeFAQKey })
		}
	}

	render(){
		const { bvKeyMigrationEnabled } = this.props
		const { activeFAQKey } = this.state
		return (
			<div>
				<PanelGroup
					activeKey={activeFAQKey}
					onSelect={this.handleFAQSelect}
					bsClass="col-xs-10 col-md-10 bv-faq-accordion-list"
					id="bluehost"
					accordion
				>
					<Panel eventKey="1">
						<Panel.Heading bsClass="panel-heading">
							<Panel.Title toggle>
								<p className="bv-faq-que">
									{ activeFAQKey == "1" ? <i className="mdi mdi-minus"></i> : <i className="mdi mdi-plus"></i> }
									What is Destination Site URL?
								</p>
							</Panel.Title>
						</Panel.Heading>
						<Panel.Body collapsible>
							<p className="bv-faq-ans">
								Destination Site URL of the site you are moving to.
							</p>
						</Panel.Body>
					</Panel>

					<Panel eventKey="2">
						<Panel.Heading bsClass="panel-heading">
							<Panel.Title toggle>
								<p className="bv-faq-que">
									{ activeFAQKey == "2" ? <i className="mdi mdi-minus"></i> : <i className="mdi mdi-plus"></i> }
									Where can I find my cPanel Credentials?
								</p>
							</Panel.Title>
						</Panel.Heading>
						<Panel.Body collapsible>
							<p className="bv-faq-ans">
								Your cPanel username is usually your domain name.
								Your cPanel password is the same password you use to login to your BlueHost account.
							</p>
						</Panel.Body>
					</Panel>

					{bvKeyMigrationEnabled ? <MigrationKeyPanel eventKey='4' activeFAQKey={activeFAQKey}/> : null}
				</PanelGroup>
			</div>
		)
	}
}

export default BluehostFAQs
